// src/setupGlobalErrorHandlers.ts
export function setupGlobalErrorHandlers() {
  window.addEventListener("error", (ev) => {
    try {
      const payload = {
        message: (ev && (ev as ErrorEvent).message) || "Unknown error",
        filename: (ev as any).filename || null,
        lineno: (ev as any).lineno || null,
        colno: (ev as any).colno || null,
      };
      console.error("[global error]", payload);
      window.dispatchEvent(new CustomEvent("app:fatalError", { detail: { message: `Error: ${payload.message}` } }));
      try { localStorage.setItem(`global_err_${Date.now()}`, JSON.stringify(payload)); } catch {}
    } catch {}
  });

  window.addEventListener("unhandledrejection", (ev) => {
    try {
      const reason = (ev as PromiseRejectionEvent).reason;
      console.error("[unhandledrejection]", reason);
      window.dispatchEvent(new CustomEvent("app:fatalError", { detail: { message: `Promise rejection: ${String(reason)}` } }));
      try { localStorage.setItem(`promise_err_${Date.now()}`, JSON.stringify({ reason: String(reason) })); } catch {}
    } catch {}
  });
}
